import apiClient from './api';

/**
 * API client for the persisted per-app project files (the server-side workspace
 * directory). The WebContainer mirrors these for the live preview; this service is
 * the persistence layer behind the Code tab.
 */
export const projectFilesService = {
    async list(applicationId: string): Promise<string[]> {
        const res = await apiClient.get(`/studio/applications/${applicationId}/files`);
        return res.data?.data?.files ?? [];
    },

    async read(applicationId: string, path: string): Promise<string> {
        const res = await apiClient.get(`/studio/applications/${applicationId}/files/content`, { params: { path } });
        return res.data?.data?.contents ?? '';
    },

    /** Read every file as a path->contents map (for the initial WebContainer mount) — one request. */
    async readAll(applicationId: string): Promise<Record<string, string>> {
        const res = await apiClient.get(`/studio/applications/${applicationId}/files/all`);
        return res.data?.data?.files ?? {};
    },

    async write(applicationId: string, path: string, contents: string): Promise<void> {
        await apiClient.put(`/studio/applications/${applicationId}/files/content`, { path, contents });
    },

    async remove(applicationId: string, path: string): Promise<void> {
        await apiClient.delete(`/studio/applications/${applicationId}/files`, { params: { path } });
    },

    async rename(applicationId: string, from: string, to: string): Promise<void> {
        await apiClient.post(`/studio/applications/${applicationId}/files/rename`, { from, to });
    },
};
